import { Card, Typography } from '@dtx-company/design-system/src'
import { CardMedia } from '@mui/material'
import { CodeConfigurationField } from '@dtx-company/inter-app/src/types/flowcode'
import { ScanDestinationOption } from './hooks/useScanDestinationOptions'
import { selectScanDestinationType } from '@app/code/src/machines/locg/locgSelectors'
import { useGlobalServices } from '@app/common/src/hooks/useGlobalServices'
import { useSelector } from '@xstate/react'
import React, { FC } from 'react'

export type ScanDestinationRadioCardProps = ScanDestinationOption

export const ScanDestinationRadioCard: FC<ScanDestinationRadioCardProps> = ({
  label,
  value,
  Icon: Icon
}) => {
  const { locgService } = useGlobalServices()
  const selectedScanDestinationType = useSelector(locgService, selectScanDestinationType)
  const isSelected = selectedScanDestinationType === value

  const onChange = (): void => {
    locgService.send({ type: 'CHANGE', key: CodeConfigurationField.SCAN_DESTINATION_TYPE, value })
  }

  return (
    <Card
      variant="outlined"
      component="label"
      data-heap-id="LoggedOutGenerator_ScanDestinationTypeInput"
      data-value={value}
      sx={theme => ({
        position: 'relative',
        width: '100%',
        display: 'flex',
        flexDirection: 'column',
        justifyContent: 'center',
        alignItems: 'center',
        py: 3,
        boxShadow: isSelected ? theme.shadows[1] : theme.shadows[0],
        ':hover': {
          boxShadow: theme.shadows[1]
        },
        borderColor: isSelected ? 'onSurface.primary' : 'border.divider',
        borderWidth: '1px',
        ...(isSelected && { outline: `1px solid ${theme.palette.onSurface.primary}` }),
        overflow: 'visible', // allow focus ring to be visible
        cursor: 'pointer',
        input: {
          appearance: 'none',
          position: 'absolute',
          inset: 0,
          margin: 0,
          cursor: 'pointer'
        }
      })}
    >
      <CardMedia>
        <Icon />
      </CardMedia>
      <Typography component="span" variant="labelLarge" noWrap align="center">
        {label}
      </Typography>
      <input
        type="radio"
        name={CodeConfigurationField.SCAN_DESTINATION_TYPE}
        value={value}
        onChange={onChange}
      />
    </Card>
  )
}
